export default __webpack_public_path__ + "_/shared_modules/sprites/dist/sprite-icons@2x-dc6a8d249b5b1bbbf04aa9f8b33eb6a5.png";